<script setup lang="ts">
import { computed } from 'vue';
import type { ProductWithDetails } from '../../types';

const props = defineProps<{
  product: ProductWithDetails;
}>();

const laboratoriesWithPrices = computed(() => {
  return props.product.laboratories.map(lab => {
    const precioVentaPar = Math.round(lab.details.PrecioDeCosto * props.product.Factor);
    return {
      ...lab,
      precioVentaPar,
      precioVentaUnidad: Math.round(precioVentaPar / 2)
    };
  });
});
</script>

<template>
  <div class="overflow-x-auto">
    <table class="table-elegant">
      <thead>
        <tr>
          <th>Laboratorio</th>
          <th>Precio Par</th>
          <th>Precio Unidad</th>
          <th>Tiempo de Demora</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="lab in laboratoriesWithPrices" :key="lab.laboratory.id">
          <td>{{ lab.laboratory.Nombre }}</td>
          <td class="font-medium text-indigo-600">
            ${{ lab.precioVentaPar.toLocaleString() }}
          </td>
          <td class="font-medium text-indigo-600">
            ${{ lab.precioVentaUnidad.toLocaleString() }}
          </td>
          <td>{{ lab.details.TiempoDeDemora }}</td>
        
        </tr>
      </tbody>
    </table>
  </div>
</template>